import { useState } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

import useLanguageChange from "../../hooks/useLanguageChange";

import { CALL_DATA, GLOBAL_MEETING_DATA } from "../../constants/PublicVariables";
import { APIs } from "../../constants/APIConstants";
import { EVENT_NAME, EXTRA_PARAM_NAME } from "../../constants/GTagConstants";
import { UPLOAD_FILE_DATA_TRACK_STATUS } from "../../constants/UploadFilesConstants";

import { deleteContainerImageFromArrayByName } from "../../reducers/imageContainer-reducer";
import uploadFilesService from "../../services/uploadFilesService";

import CustomToast from "../UI/customToast";
import api from "../../apis/api";
import { LogFirebase } from "../../services/firestore";
import googleEvent from "../../services/googleEvent";

import CenterModal from "../UI/Modal/CenterModal";

const DeleteImageFromContainer = (props) => {
    const { deleteImgObj } = props;
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();
    const [deleteInProgress, setDeleteInProgress] = useState(false);

    const failDeleteImage = () => {
        closeDeleteImageModal();
        CustomToast.error(localisedValues?.failed_to_delete_image);
        LogFirebase("DeleteImage", "DeleteFailed", { image_name: deleteImgObj.name, image_url: deleteImgObj.original });
    };

    const callDeleteImageAPI = () => {
        if (!deleteInProgress) {
            setDeleteInProgress(true);
            LogFirebase("DeleteImage", "DeleteConfirmed", { imageName: deleteImgObj.name });
            if (deleteImgObj?.name) {
                const deleteImageUrl = APIs.DELETE_IMAGE + GLOBAL_MEETING_DATA.sessionId;
                const request = {
                    MemberId: CALL_DATA.memberId,
                    Files: [
                        {
                            name: deleteImgObj.name,
                            uploadtype: deleteImgObj.uploadType ? deleteImgObj.uploadType : "0",
                        },
                    ],
                };
                if (CALL_DATA.memberToken) {
                    request.headers = {
                        token: CALL_DATA.memberToken,
                    };
                }

                api.deleteStorage(deleteImageUrl, request)
                    .then((response) => {
                        if (response.success > 0) {
                            LogFirebase("DeleteImage", "DeleteSuccess", { imageName: deleteImgObj.name });
                            // handle remaining count and send datatrack
                            GLOBAL_MEETING_DATA.remainingFileCount = response.data.remainingFiles;
                            uploadFilesService.sendTrackOnUploadFileStartEnd(UPLOAD_FILE_DATA_TRACK_STATUS.REMAINING_COUNT); // upload file remaining count msg send
                            dispatch(deleteContainerImageFromArrayByName(deleteImgObj.name));
                            googleEvent.logEvent(EVENT_NAME.IMAGE_DELETED, EXTRA_PARAM_NAME.DELETED_IMAGE_NAME, deleteImgObj.name);
                            closeDeleteImageModal();
                            CustomToast.success(localisedValues?.image_deleted);
                        } else {
                            failDeleteImage();
                        }
                    })
                    .catch((err) => {
                        failDeleteImage();
                    });
            }
        }
    };

    const closeDeleteImageModal = () => {
        setDeleteInProgress(false);
        props.closeDeleteModal();
    };

    const deleteModalHeader = (
        <>
            <h5 className='modal-title'>{localisedValues?.delete_image_title}</h5>
            <button type='button' className='btn-close' aria-label='Close' onClick={closeDeleteImageModal}>
                <span className='btn-icon icon-close-light'></span>
            </button>
        </>
    );

    const deleteModalBody = (
        <div className='privacy-policy-modal-text'>
            <p>{localisedValues?.are_you_sure_you_want_to_delete_image}</p>
        </div>
    );

    const deleteModalFooter = (
        <div className='button-inline more-space button-inline-tb-space d-flex align-items-center'>
            <div className='button'>
                <button className='btn default-btn-link' onClick={closeDeleteImageModal}>
                    {localisedValues?.cancel}
                </button>
            </div>
            <div className='button'>
                <button className='btn default-btn-primary' disabled={deleteInProgress} onClick={callDeleteImageAPI}>
                    {localisedValues?.delete_lable}
                </button>
            </div>
        </div>
    );

    return (
        <CenterModal
            showModal={!!deleteImgObj}
            closeModal={closeDeleteImageModal}
            className='modal-dialog modal-dialog-centered'
            modalClass='default-modal modal-small mob-bottom-top'
            bodyClassName='default-custom-scroll'
            header={deleteModalHeader}
            body={deleteModalBody}
            footer={deleteModalFooter}
            backdrop={"static"}
        />
    );
};

DeleteImageFromContainer.propTypes = {
    closeDeleteModal: PropTypes.func.isRequired,
    deleteImgObj: PropTypes.object.isRequired,
};

export default DeleteImageFromContainer;
